// export default function loadFroged() {
//   return new Promise((resolve, reject) => {
//     ;(function () {
//       var a = document,
//         b = window
//       if ('function' != typeof window['Froged']) {
//         ;(window['Froged'] = function (a, b, c) {
//           window['Froged'].c(a, b, c)
//         }),
//           (window['Froged'].q = []),
//           (window['Froged'].c = function (a, b, c) {
//             window['Froged'].q.push([a, b, c])
//           }),
//           (window['fg_data'] = { hooks: {} })
//         var c = function () {
//           var b = a.createElement('script')
//           ;(b.type = 'text/javascript'),
//             (b.async = !0),
//             (b.src = 'https://6e8hmq.sdk.froged.com')
//           var c = a.getElementsByTagName('script')[0]
//           c.parentNode.insertBefore(b, c)
//         }
//         'complete' === a.readyState
//           ? c()
//           : window.attachEvent
//           ? b.attachEvent('onload', c)
//           : b.addEventListener('load', c, !1)
//       }
//     })()
//   })
// }


export default function loadFroged() {
  return new Promise((resolve, reject) => {
    var v, w, x, y, z
    var o = (window['Froged'] = window['Froged'] || {})
    o._q = o._q || []
    v = ['initialize', 'identify', 'updateOptions', 'pageLoad', 'track']
    for (w = 0, x = v.length; w < x; ++w)
      (function (m) {
        o[m] =
          o[m] ||
          function () {
            o._q[m === v[0] ? 'unshift' : 'push'](
              [m].concat([].slice.call(arguments, 0)),
            )
          }
      })(v[w])
    y = document.createElement('script')
    y.async = true
    y.src = 'https://6e8hmq.sdk.froged.com'
    y.onload = () => resolve(window['Froged'])
    y.onerror = (err) => reject(err)
    z = document.getElementsByTagName('script')[0]
    z.parentNode.insertBefore(y, z)
  })
}
